/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SubjectContactItemDto } from './subjectContactItemDto.model';
import { ContractSimpleDto } from './contractSimpleDto.model';
import { BarterSimpleDto } from './barterSimpleDto.model';


export interface IncomingPaymentDto { 
    amount?: number;
    barter?: BarterSimpleDto;
    contract?: ContractSimpleDto;
    id?: number;
    paymentGenerationDate?: string;
    paymentPaidDate?: string;
    paymentYear?: number;
    payoutDate?: string;
    recipient?: SubjectContactItemDto;
    sender?: SubjectContactItemDto;
    state?: string;
}

